module.exports = __webpack_public_path__ + "img/BG terrazzo vanilla.64c4f345.svg";